import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';

// A subscription start date is UTC, not browser time: the billing anchor renews
// at 00:00 UTC, and a local midnight sits hours off it, so Stripe prorates the gap.
export const toStartDateInput = date =>
  formatInTimeZone(new Date(date), 'UTC', "yyyy-MM-dd'T'HH:mm");

export const fromStartDateInput = value => fromZonedTime(value, 'UTC');
